import { useTranslation } from 'react-i18next';
import classes from './PageLoader.module.css';

/**
 * While Trustpulse finds out who is logged in. index.html shows the same loader before the app
 * has started, so a refresh goes straight from one to the other.
 */
export const PageLoader = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.container} role="status">
      <img src="/trustpulse-logo.png" alt="" width={190} height={33} className={classes.logo} />
      <span className={classes.track} aria-hidden="true">
        <span className={classes.bar} />
      </span>
      <span className="ds-sr-only">{t('pageLoader.loading')}</span>
    </div>
  );
};
